"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _Typography = _interopRequireDefault(require("../Typography"));

var _style = require("./style");

var _excluded = ["type", "prefix", "onClick", "popup", "disabled"];

var _this = void 0;

/**
 * ConfigInfo.ActionIcon
 * @description 配置信息项的操作图标
 */
var ActionIcon = function ActionIcon(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var type = _ref.type,
      prefix = _ref.prefix,
      onClick = _ref.onClick,
      popup = _ref.popup,
      disabled = _ref.disabled,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderIcon = function renderIcon() {
    (0, _newArrowCheck2["default"])(this, _this2);
    return /*#__PURE__*/_react["default"].createElement(_style.StyledIcon, (0, _extends2["default"])({
      type: type,
      prefix: prefix,
      onClick: !disabled ? onClick : null,
      disabled: disabled
    }, others));
  }.bind(this);

  if (popup) {
    return /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
      placement: "top",
      popup: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        size: "sm"
      }, popup),
      getPopupContainer: function () {
        (0, _newArrowCheck2["default"])(this, _this2);
        return document.body;
      }.bind(this)
    }, renderIcon());
  }

  return renderIcon();
}.bind(void 0);

ActionIcon.propTypes = {
  /**
   * 图标类型
   */
  type: _propTypes["default"].string,

  /**
   * 自定义icon类名前缀
   */
  prefix: _propTypes["default"].string,

  /**
   * 点击时的回调
   */
  onClick: _propTypes["default"].func,

  /**
   * 弹出层内容
   */
  popup: _propTypes["default"].node,

  /**
   * 是否禁用，如果为true，则不响应onClick
   */
  disabled: _propTypes["default"].bool
};
ActionIcon.defaultProps = {
  type: "edit",
  prefix: "icon-uc-action__"
};
var _default = ActionIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ConfigInfo/ActionIcon.js
// module id = 2099
// module chunks = 6 7 17 18